import { Component, OnInit } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'cellRender-valuec',
    templateUrl: './cellRender-valuec.component.html'
})
export class CellRenderValueCComponent implements OnInit {

    params: any;
    valuec: number;
    value: number;
    differencec: number;
    percentChangec: number;
    displayAllValues: boolean = true;
    displayCurrencyMobile:  boolean = false;
    cellClass: string = '';
    colName: string;
    rowData: any;

    constructor(
        private translationService: PershingTranslationService
    ) { 
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
    }

    agInit(params: any) {
        this.params = params;
    }

    ngOnInit() {
        if (!!this.params) {
            if (!!this.params.data) {
                this.rowData = this.params.data;
                this.valuec = this.rowData.valuec ? this.rowData.valuec : 0;
                this.differencec = !!this.rowData.differencec ? this.rowData.differencec : 0;
                this.percentChangec = !!this.rowData.percentChangec ? this.rowData.percentChangec : 0;
                this.displayAllValues = !!this.rowData.displayAllValues ? this.rowData.displayAllValues : false;
                this.cellClass = !!this.rowData.class ? this.rowData.class : '';
            }
        }
    }
}
